import env from '../../env';
import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const getRMA = createAsyncThunk('rma/getRMA', async (arg, { rejectWithValue }) => {
  try {
    const { data } = await axios.get(`${env.API_URL}/rmas/${arg}?populate=*`, {
      headers: {
        jwt: localStorage.getItem('microsoftJWT'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
    return data.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const putRMA = createAsyncThunk('rma/putRMA', async (arg, { rejectWithValue }) => {
  const { rmaID, updateData } = arg;
  const username = localStorage.getItem('username');
  try {
    const { data } = await axios.put(
      `${env.API_URL_PREFIX}/update-rma/${rmaID}`,
      { ...updateData, username },
      {
        headers: {
          jwt: localStorage.getItem('microsoftJWT'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    return data.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const patchRMAHistory = createAsyncThunk('rma/patchRMAHistory', async (arg, { rejectWithValue }) => {
  const { rmaID, patch } = arg;
  const username = localStorage.getItem('username');
  try {
    await axios.put(
      `${env.API_URL_PREFIX}/update-rma/${rmaID}`,
      { historyPatch: patch, username },
      { headers: { jwt: localStorage.getItem('microsoftJWT'), Accept: 'application/json', 'Content-Type': 'application/json' } }
    );
    return { ok: true };
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});

export const putARTICLE = createAsyncThunk('rma/putARTICLE', async (arg, { rejectWithValue }) => {
  const { articleID, updateData } = arg;
  try {
    const { data } = await axios.put(
      `${env.API_URL_PREFIX}/update-article/${articleID}`,
      updateData,
      {
        headers: {
          jwt: localStorage.getItem('microsoftJWT'),
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      }
    );
    return data.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data ?? err.message);
  }
});
